// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3HCf3","topBottomGutter":"Layout_topBottomGutter__3vvOV"};